/* eslint-disable */
// NOTE :: DO NOT EDIT :: this file is automatically generated by generate-environment-variables.js node script

export const envVariables: { [key: string]: string } = {
  CIRCLE_TAG: 'prod-purposeful-v97',
  PRODUCT: 'purposeful'
};
export const latestTag = 'prod-purposeful-v97';
export const latestVersion = 'v97';
export const versions = {
  app: {
    purposeful: '5.6.2',
    resourceful: '5.6.2',
    insightful: '2.7.1'
  },
  branch: 'HEAD',
  npm_version: '127.0.0',
  revision: '8446d3b2c'
};
/* eslint-enable */
